import { render, staticRenderFns } from "./TextDivider.vue?vue&type=template&id=0a17215e&scoped=true&"
import script from "./TextDivider.vue?vue&type=script&lang=js&"
export * from "./TextDivider.vue?vue&type=script&lang=js&"
import style0 from "./TextDivider.vue?vue&type=style&index=0&id=0a17215e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a17215e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
